import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { LocalProfileProvider } from "./local/useLocalProfile";
import "./design.css";
import "./styles.css";
import "./game/game.css";
import "./ui-system.css";
// FBX character preload disabled — animation retargeting onto the procedural
// primitive character isn't implemented. Re-enable these imports + calls if
// we add a skeleton trampoline that lets Mixamo clips drive primitive pivots.
// import { preloadCharacterModel, preloadRunClip } from "./game/engine/characterModel";

declare const __BUILD_ID__: string;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LocalProfileProvider>
        <App />
      </LocalProfileProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Dismiss the inline boot loader once the app has mounted and painted a couple
// of frames behind it (so the menu is ready before we cross-fade to it). Keep
// it up a short minimum so a fast load doesn't flash.
(() => {
  const loader = document.getElementById("boot-loader");
  if (!loader) return;
  const MIN_MS = 650;
  const t0 = performance.now();
  const hide = () => {
    const wait = Math.max(0, MIN_MS - (performance.now() - t0));
    window.setTimeout(() => {
      loader.classList.add("bl-hide");
      window.setTimeout(() => loader.remove(), 600);
    }, wait);
  };
  // Two rAFs ≈ the app's first real paint; then fade.
  requestAnimationFrame(() => requestAnimationFrame(hide));
})();

const tag = document.createElement("div");
tag.textContent = `v${__BUILD_ID__}`;
tag.style.cssText =
  "position:fixed;left:6px;bottom:4px;z-index:9999;font:600 10px/1 system-ui,sans-serif;color:rgba(255,255,255,0.6);text-shadow:0 1px 2px rgba(0,0,0,0.6);pointer-events:none;letter-spacing:0.5px;";
document.body.appendChild(tag);
